const updateCreatorMembershipsLoading = (state, { payload: { loading } }) => {
	state.creatorMembershipsLoading = loading;
};

export default updateCreatorMembershipsLoading;
